const routes = [{
  path: '/ultimate/finance/report',
  component: () => import('@/views/ultimate/finance/report'),
  name: 'ultimate-finance-report',
  meta: {
    title: '财务明细报表'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/ultimate/finance.js